<template>
  <div class="range" ref="range_bar">
    <div class="range-btn range-left"
         ref="range_left"
         id="left"
         data-ref="range_left" :style="{left: minX + 'px'}"></div>
    <div class="range-btn range-right"
         ref="range_right"
         id="right"
         data-ref="range_left" :style="{left: maxX + 'px'}"></div>
    <i class="cicle"></i>
  </div>
</template>
<script>
  import { Range } from './range';
  export default {
    name: 'range',
    props: {
      minLeft: {
        default: 0,
        type: Number
      },
      maxLeft: {
        default: 0,
        type: Number
      }
    },
    data() {
        return {
          minX: this.minLeft || 0,
          maxX: this.maxLeft || 216,
          init: null,
          targetBtn: '',
        }
    },
    methods: {

    },
    mounted () {
      let that = this;
      this.$nextTick(() => {
        this.min = new Range('left', 'right').init(function(x){
          that.minX = x;
          that.$emit('min', x/(250-68));
        }, function (x) {
          let leftMove = x/(250-68);
          that.$emit('left', leftMove);
        })
        this.max = new Range('right', 'left').init(function(x){
          that.maxX = x;
          that.$emit('max', (x-34)/(250-68));
        }, function (x) {
          let leftMove = (x-34)/(250-68);
          that.$emit('right', leftMove);
        })
      })
    }
  }
</script>
<style lang="scss" scoped>
  .range{
    position: relative;
    height: 6px;
    width: 250px;
    height: 34px;
    overflow: hidden;
    &:before{
      position: absolute;
      content: "";
      display: block;
      width: 100%;
      height: 6px;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background: #088de8;
      border-radius: 3px;
    }
    .cicle{
      &:after, &:before{
        position: absolute;
        content: "";
        display: block;
        height: 6px;
        width: 6px;
        background: {
          repeat: no-repeat;
          size: 3px 6px;
          image: url("../../static/images/cicle1.png");
        };
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        left: 0;
      }
      &:after{
        left: auto;
        right: 0;
        transform: rotate(180deg);
        transform-origin: 50% 25%;
      }
    }
    .range-btn{
      position: absolute;
      top: 50%;
      left: 20%;
      width: 34px;
      border-radius: 50%;
      height: 34px;
      transform: translateY(-50%);
      cursor: pointer;
      background: {
        repeat: no-repeat;
        size: 34px 34px;
        color: white;
        image: url("../../static/images/btn@2x.png");
      };
      z-index: 2;
      &:before{
        position: absolute;
        content: "";
        display: block;
        height: 6px;
        width: 300px;
        background: #BCBCBD;
        left: -300px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
      }
      &.range-right{
        left: 60%;
        &:before{
          left: auto;
          right: -300px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RangeSlide.vue